import DateScenarioPage from '../date-management/DateScenarioPage';

const toBoolean = (value) => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
};

const examEndpoints = {
  list: ({ programId, filters, page, limit }) => ({
    url: programId ? `programs/${programId}/exam-dates` : '',
    query: {
      page: page ?? undefined,
      limit: limit ?? undefined,
      academic_year: filters?.academicYear ? Number(filters.academicYear) : undefined,
      exam_type: filters?.examType || undefined,
      is_active: toBoolean(filters?.isActive),
      include_deleted: toBoolean(filters?.includeDeleted),
    },
  }),
  create: ({ programId }) => ({
    url: programId ? `programs/${programId}/exam-dates` : '',
  }),
  update: ({ programId, recordId }) => ({
    url: programId ? `programs/${programId}/exam-dates/${recordId}` : '',
  }),
  delete: ({ programId, recordId }) => ({
    url: programId ? `programs/${programId}/exam-dates/${recordId}` : '',
  }),
};

const ExamDatesPage = () => (
  <DateScenarioPage
    titleKey="EXAM_DATES_TITLE"
    subtitleKey="EXAM_DATES_SUBTITLE"
    entityNameKey="DATE_SCENARIO_ENTITY_EXAM"
    emptyStateKey="EXAM_DATES_EMPTY"
    addButtonKey="EXAM_DATES_ADD_BUTTON"
    scenarioType="exam"
    endpoints={examEndpoints}
  />
);

export default ExamDatesPage;

